import { Injectable } from '@angular/core';
import { JsonTypes } from 'typedjson';
import QueryString from 'qs';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsTransformerService {
  public stringify(object: JsonTypes): string {
    return QueryString.stringify(object, {
      skipNulls: true,
      arrayFormat: 'indices',
    });
  }
}
